










































































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { Getter } from "vuex-class";

import { IOrderDto } from "@/types/interface/IOrderDto";
import { OrderDto } from "@/types/impl/OrderDto";
import { IUserInfoDto } from "../../../types/interface/IUserInfoDto";
import IImageComponent from "@/components/image.vue";
import DeliveryTypeComponent from "@/components/delivery-type.vue";
import PaymentStatusComponent from "@/components/payment-status.vue";
import { toLocalTime, Operatore } from "../../../api/net/util";
import { IOrderParkingLotDto } from "../../../types/interface/IOrderParkingLotDto";
import { OrderStatus, DeliveryType } from "../../../types/enum/OrderEnum";
@Component({
  components: {
    IImageComponent,
    DeliveryTypeComponent,
    PaymentStatusComponent
  }
})
export default class RowHeader extends Vue {
  @Prop({ default: { ...OrderDto } }) order!: IOrderDto;
  @Prop({
    type: Function,
    default: (orderId: string) => {}
  })
  toOrderDetail!: (orderId: string) => {};
  @Getter("isPc") isPc!: boolean;

  userOrderScores: Array<{ good: number; bad: number; icon: string }> = [
    {
      icon: "mdi-storefront",
      good: this.user.userOrderScores.positiveOrderForShop || 0,
      bad: this.user.userOrderScores.negativeOrderForShop || 0
    },
    {
      icon: "yamimeal",
      good: this.user.userOrderScores.positiveOrderForPlatform || 0,
      bad: this.user.userOrderScores.negativeOrderForPlatform || 0
    }
  ];
  public get orderSN(): string {
    return this.order.serialNumber ? `No.${this.order.serialNumber}` : "";
  }

  public get user(): IUserInfoDto {
    return this.order.user;
  }

  public get avatar(): string {
    return this.user.picture;
  }

  public get pickupTime(): string {
    return toLocalTime(
      `${this.order.systemCalculatedReadyForPickupTime}`,
      Operatore.Horizontal
    );
  }

  public get PaymentSubmittedDate(): string {
    if (this.order.paymentSubmittedDate === null) {
      return `No Time`;
    } else {
      return toLocalTime(
        `${this.order.paymentSubmittedDate}`,
        Operatore.Horizontal
      );
    }
  }

  public get userExpectedPickupDate(): string {
    if (this.order.userExpectedPickupDate) {
      return toLocalTime(
        `${this.order.userExpectedPickupDate}`,
        Operatore.Horizontal
      );
    } else {
      return "";
    }
  }

  public get deliveryStartTime(): string {
    if (this.order.userExpectedDeliveryTimeRangeStart) {
      return toLocalTime(
        `${this.order.userExpectedDeliveryTimeRangeStart}`,
        Operatore.Horizontal
      );
    } else {
      return "";
    }
  }

  public get deliveryEndTime(): string {
    if (this.order.userExpectedDeliveryTimeRangeEnd) {
      return toLocalTime(
        `${this.order.userExpectedDeliveryTimeRangeEnd}`,
        Operatore.Horizontal
      ).split(" ")[1];
    } else {
      return "";
    }
  }

  public get merchantConfirmedDeliveryTimeRangeStart(): string {
    if (this.order.merchantConfirmedDeliveryTimeRangeStart) {
      return toLocalTime(
        `${this.order.merchantConfirmedDeliveryTimeRangeStart}`,
        Operatore.Horizontal
      );
    } else {
      return "";
    }
  }

  public get merchantConfirmedDeliveryTimeRangeEnd(): string {
    if (this.order.merchantConfirmedDeliveryTimeRangeEnd) {
      return toLocalTime(
        `${this.order.merchantConfirmedDeliveryTimeRangeEnd}`,
        Operatore.Horizontal
      ).split(" ")[1];
    } else {
      return "";
    }
  }

  public get isShowDeliveryTime(): boolean {
    if (
      this.order.userExpectedDeliveryTimeRangeStart &&
      this.order.userExpectedDeliveryTimeRangeEnd
    )
      return true;
    else return false;
  }

  public get orderParkingLotPickupFieldValues(): IOrderParkingLotDto[] {
    return this.order.orderParkingLotPickupFieldValues;
  }

  public get showCustomerExpectedTime(): boolean {
    return (
      this.order.orderStatus === OrderStatus.WaitingForAcceptance ||
      this.order.orderStatus === OrderStatus.Rejected
    );
  }

  public get DeliveryType(): any {
    return DeliveryType;
  }

  public get customerExpectedDeliveryTimeCrossDay(): boolean {
    if (
      this.order.userExpectedDeliveryTimeRangeStart &&
      this.order.userExpectedDeliveryTimeRangeEnd
    ) {
      let userExpectedDeliveryTimeRangeStartDate = toLocalTime(
        `${this.order.userExpectedDeliveryTimeRangeStart}`,
        Operatore.Horizontal
      ).split(" ")[0];

      let userExpectedDeliveryTimeRangeEndDate = toLocalTime(
        `${this.order.userExpectedDeliveryTimeRangeEnd}`,
        Operatore.Horizontal
      ).split(" ")[0];
      return (
        userExpectedDeliveryTimeRangeStartDate !==
        userExpectedDeliveryTimeRangeEndDate
      );
    } else {
      return false;
    }
  }

  public get merchantConfirmedDeliveryTimeCrossDay(): boolean {
    if (
      this.order.merchantConfirmedDeliveryTimeRangeStart &&
      this.order.merchantConfirmedDeliveryTimeRangeEnd
    ) {
      let merchantConfirmedDeliveryTimeRangeStartDate = toLocalTime(
        `${this.order.merchantConfirmedDeliveryTimeRangeStart}`,
        Operatore.Horizontal
      ).split(" ")[0];
      let merchantConfirmedDeliveryTimeRangeEndDate = toLocalTime(
        `${this.order.merchantConfirmedDeliveryTimeRangeEnd}`,
        Operatore.Horizontal
      ).split(" ")[0];
      return (
        merchantConfirmedDeliveryTimeRangeStartDate !==
        merchantConfirmedDeliveryTimeRangeEndDate
      );
    } else {
      return false;
    }
  }
}
